
export const platformTableApis = {

};

export const authApis = {
    loginApi : "auth/api/signin",
    changePasswordApi : "auth/api/change-password",
    getMenuLinks : "users/menulinks",
    logoutApi : "auth/api/signout"
};

export const assignmentApis = {
    stateHolidaysApi : "loan/platform/{version}/api/stateHolidays?hierarchyType=ALWAYS_NON_HIERARCHY&size=1&page=0&search=holidayDate:eq{input}"
}

export const recordDetailsApis = {

};

export const geoLoactionApis = {
   tripCoordinatesApi : "trip/geo/coordinates",
   fosTodoForPlottingApi : "loan/platform/api/blueprint/{version}/fosTodoForPlotting",
   fosTodoPlottingSearchFilterApi: "loan/platform/api/blueprint/{version}/fosTodoPlottingSearchFilter"
};

export const readyReckonerApis = {
    readyReckonerView: "loan/platform/api/blueprint/{version}/readyRecknorView"
};


export const vernacularBlueprintApis:Object = {
    "kn": "users/vernacular/generate-url-info/vernacularNomenclatureKN.json",
    "te": "users/vernacular/generate-url-info/vernacularNomenclatureTE.json",
    "hi": "users/vernacular/generate-url-info/vernacularNomenclatureHI.json",
    "ta": "users/vernacular/generate-url-info/vernacularNomenclatureTA.json",
    "gu": "users/vernacular/generate-url-info/vernacularNomenclatureGU.json",
    "mr": "users/vernacular/generate-url-info/vernacularNomenclatureMH.json",
    "bn": "users/vernacular/generate-url-info/vernacularNomenclatureBN.json",
    "ml": "users/vernacular/generate-url-info/vernacularNomenclatureML.json",
    "or": "users/vernacular/generate-url-info/vernacularNomenclatureOD.json"
};  


export const reconciliationApis = {
    manualReconciliationPlatformRecordEdit : "payments/blueprint/{version}/manualReconciliationPlatformRecordEdit",
    manualReconciliationBankStatementEdit:"payments/blueprint/{version}/manualReconciliationBankStatementEdit",
    reconciliationDataTable:"payments/blueprint/{version}/reconciliationDataTable",
    reconciliationSearchFilter:"payments/blueprint/{version}/reconciliationSearchFilter",
    bankStatementsDataTable:"payments/blueprint/{version}/bankStatementsDataTable",
    bankStatementDataTableSearchFilter:"payments/blueprint/{version}/bankStatementDataTableSearchFilter"

}

export const userProfileApis = {
    myinfoApi: "users/my-info",
    createProfileApi : "auth/platform/api/profiles",
    getProfileApi : "auth/platform/api/profiles/{recordId}",
    passowrdUpdateApi : "auth/user/changePassword"
}

export const homePageApis = {
    homePageLayout : "users/homepage/layout"
}

export const commonApis = {
    notficationsApi : "notifications/platform/{version}/api/notifications"
}